// extracted by mini-css-extract-plugin
export default {"btn-edit":"SetPassword_btn-edit__tBzRc","btn-cancle":"SetPassword_btn-cancle__4H1Ko","section-content":"SetPassword_section-content__HsGYg"};